import React from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'

// import { connect } from 'react-redux'

// import createHistory from 'history/createBrowserHistory';
import LoginPage from './LoginPage'
import FormPage from './FormPage'
// import LandingPage from '../components/common/LandingPage'

import { history } from './history'

class AppRouter extends React.Component {
  
 render() {
  //  console.log('ROUTER PROPS', this.props)
  return(
  <Router history={history} basename="/aarp/">
    <Switch>
      <Route path="/" exact={true} component={LoginPage} />
      <PrivateRoute path="/form" component={FormPage} />

      <Redirect from="*" to="/" />
   
    </Switch>
  </Router>
  // </div>
)
}
}

export default AppRouter
